// <head> подбора без кабинета: старт и результат. Как у /start — noindex:
// это шаг формы, а не страница для поиска. Результат — личный документ.
import guestCss from "./abroad-guest.css?url";
import { ABROAD_GUEST_START_PATH, GUEST_HEAD_COPY, type GuestLang } from "@/edu/guest";
import { SITE_CHROME_LINKS } from "@/components/site/site-chrome-head";
import { OG_LOCALE, ogImageMeta, socialMeta } from "@/lib/page-meta";
import {
  GUEST_INVITE_OG,
  guestInviteOgImagePath,
  guestInvitePath,
  guestStartOgImagePath,
  OG_IMAGE_REV,
  type InviteView,
} from "@/edu/guest-invite";
import { withCountries } from "@/edu/countries-count";
import type { CountriesHead } from "@/lib/edu-countries-count.functions";

const SITE = "https://yolutap.com";

// ПРЕВЬЮ В МЕССЕНДЖЕРАХ (аудит 12.10). Было общее фото мальчика с главной и
// маленькая карточка. Теперь своя картинка 1200×630 на языке страницы. Одна и
// та же у старта и у отчёта — чужой отчёт по ссылке так и называется, фото
// ребёнка нет.
//
// ЧИСЛО СТРАН (C8, 13.10). Картинка рисуется на лету с числом из справочника:
// /api/og/abroad-start/<lang>?n=<число>. Loader страницы приносит число и
// хост (CountriesHead). Числа нет — статическая JPG того же макета без числа.
export const GUEST_OG_IMAGE: Record<GuestLang, string> = {
  ru: `${SITE}/og/abroad-start-ru.jpg?v=${OG_IMAGE_REV}`,
  az: `${SITE}/og/abroad-start-az.jpg?v=${OG_IMAGE_REV}`,
  en: `${SITE}/og/abroad-start-en.jpg?v=${OG_IMAGE_REV}`,
};
/** Картинка старта: на лету с числом стран, без числа — статическая JPG. */
export function guestStartOgImage(lang: GuestLang, c?: CountriesHead | null): string {
  return c?.count ? (c.origin || SITE) + guestStartOgImagePath(lang, c.count) : GUEST_OG_IMAGE[lang];
}
const ogImage = (lang: GuestLang, c?: CountriesHead | null) =>
  c?.count ? ogImageMeta(guestStartOgImage(lang, c), undefined, "image/png") : ogImageMeta(GUEST_OG_IMAGE[lang]);

export function guestStartHead(lang: GuestLang, c?: CountriesHead | null) {
  const url = SITE + ABROAD_GUEST_START_PATH[lang];
  return {
    meta: [
      ...socialMeta({ ...GUEST_HEAD_COPY[lang].start, ogDescription: GUEST_HEAD_COPY[lang].og }),
      ...ogImage(lang, c),
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
      { property: "og:locale", content: OG_LOCALE[lang] },
      { name: "robots", content: "noindex, nofollow" },
    ],
    links: [
      { rel: "canonical", href: url },
      ...SITE_CHROME_LINKS,
      { rel: "stylesheet", href: guestCss },
    ],
  };
}

export function guestResultHead(lang: GuestLang, c?: CountriesHead | null) {
  return {
    meta: [
      ...socialMeta({ ...GUEST_HEAD_COPY[lang].result, ogDescription: GUEST_HEAD_COPY[lang].og }),
      ...ogImage(lang, c),
      { property: "og:locale", content: OG_LOCALE[lang] },
      { name: "robots", content: "noindex, nofollow" },
    ],
    links: [...SITE_CHROME_LINKS, { rel: "stylesheet", href: guestCss }],
  };
}

/**
 * <head> именного приглашения. Превью в мессенджерах — именное: og:title с
 * именем и картинка, нарисованная по токену (/api/og/invite/<token>). Нет
 * приглашения или срок вышел — превью старта (общая картинка). noindex всегда.
 * Число стран в описании и в адресе картинки — из c (loader страницы).
 */
export function guestInviteHead(
  lang: GuestLang,
  token: string,
  view: InviteView | null | undefined,
  c?: CountriesHead | null,
) {
  const named = view && view.found && !view.expired ? view : null;
  const og = GUEST_INVITE_OG[lang];
  // Превью-версия рисует картинку сама: адрес — её хост (origin из сервера).
  const base = named?.origin ?? c?.origin ?? SITE;
  const n = c?.count ?? null;
  const image = named ? base + guestInviteOgImagePath(token, n) : guestStartOgImage(lang, c);
  const title = named ? og.title(named.firstName) : GUEST_HEAD_COPY[lang].start.title;
  return {
    meta: [
      ...socialMeta({ title, description: withCountries(og.description, lang, n) }),
      { property: "og:type", content: "website" },
      { property: "og:url", content: base + guestInvitePath(lang, token) },
      { property: "og:locale", content: OG_LOCALE[lang] },
      { property: "og:image", content: image },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: image },
      { name: "robots", content: "noindex, nofollow" },
    ],
    links: [...SITE_CHROME_LINKS, { rel: "stylesheet", href: guestCss }],
  };
}
